<template>
  <select-list v-if="list && list.length" :list="list" class="activity-tickets" v-model="current" :col="col">
    <template #default="{data}">
      <div class="activity-tickets__item">
        <p class="activity-tickets__title">
          {{ data.name }}
        </p>
        <p class="activity-tickets__desc">
          {{ data.cost ? `${data.cost} Points` : 'Free' }}
        </p>
      </div>
    </template>
  </select-list>
</template>

<script>
import SelectList from './SelectList';

export default {
  name: 'Sessions',
  components: {
    SelectList
  },
  props: {
    selectable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Number
    },
    list: {
      type: Array
    },
    col: {
      type: Number
    }
  },
  data(){
    return {
      current: this.value
    };
  },
  watch:{
    current(val){
      this.$emit('input', val);
    },
    value(val){
      if (val !== this.current){
        this.current = val;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.activity-tickets {
  &__title {
    @include font_tips_m();
    // font-weight: $bold;
    @include blue_sky_bold;
  }

  &__desc {
    margin-top: sizeTrans($space_10);
    @include font_tips_s();
  }
}
</style>